module.exports = __webpack_public_path__ + "img/Phone.48650645.svg";